import {
  ErrorTypes, FlattenedErrorsObjectArray, Flex, groupErrorsByNonProperty, useStyledTheme, WarningIcon,
} from '@equifinance/shared';
import styled from 'styled-components';
import { TickCircleIcon } from '../components/Icons';
import { SectionTitleIcon, SectionTitleIconProps } from './SectionTitleIcon';

export type TableStatusIconProps = SectionTitleIconProps & {
  recordErrors?: FlattenedErrorsObjectArray;
  recordWarnings?: FlattenedErrorsObjectArray;
}

const IconContainer = styled(Flex)`${({ theme }) => `
  width: ${theme.padding[6]};
`}`;

export function TableStatusIcon({
  recordErrors = [],
  recordWarnings = [],
  ...props
}: TableStatusIconProps) {
  const theme = useStyledTheme();

  const filteredErrors = groupErrorsByNonProperty(recordErrors);
  const rejectDataErrors = filteredErrors?.[ErrorTypes.RejectData] ?? [];
  const isError = rejectDataErrors.length > 0;

  const filteredWarnings = groupErrorsByNonProperty(recordWarnings);
  const referWarnings = filteredWarnings?.[ErrorTypes.Refer] ?? [];
  const warningWarnings = filteredWarnings?.[ErrorTypes.Warning] ?? [];
  const isWarning = referWarnings.length > 0 || warningWarnings.length > 0;

  if (isError || isWarning) {
    return <IconContainer><WarningIcon stroke={isError ? theme.colours.danger[1] : theme.colours.secondary[1]} fill="#ffffff" /></IconContainer>;
  }

  return <SectionTitleIcon tickIcon={<TickCircleIcon />} {...props} />;
}
